import { render, staticRenderFns } from "./filter_modificators.vue?vue&type=template&id=987874f4&scoped=true&"
import script from "./filter_modificators.vue?vue&type=script&lang=js&"
export * from "./filter_modificators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987874f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('987874f4')) {
      api.createRecord('987874f4', component.options)
    } else {
      api.reload('987874f4', component.options)
    }
    module.hot.accept("./filter_modificators.vue?vue&type=template&id=987874f4&scoped=true&", function () {
      api.rerender('987874f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/modifiers/items/filter_modificators.vue"
export default component.exports